/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Transcription_Job_Submitted_SuccessInputs */

const en_transcription_job_submitted_success = /** @type {(inputs: Transcription_Job_Submitted_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transcription job was submitted successfully`)
};

const fr_transcription_job_submitted_success = /** @type {(inputs: Transcription_Job_Submitted_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La tâche de transcription a été soumise avec succès`)
};

const de_transcription_job_submitted_success = /** @type {(inputs: Transcription_Job_Submitted_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Transkriptionsauftrag wurde erfolgreich übermittelt.`)
};

const it_transcription_job_submitted_success = /** @type {(inputs: Transcription_Job_Submitted_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il lavoro di trascrizione è stato inviato con successo`)
};

const ru_transcription_job_submitted_success = /** @type {(inputs: Transcription_Job_Submitted_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Задание по транскрипции успешно отправлено.`)
};

const es_transcription_job_submitted_success = /** @type {(inputs: Transcription_Job_Submitted_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El trabajo de transcripción se envió correctamente`)
};

const zh_cn2_transcription_job_submitted_success = /** @type {(inputs: Transcription_Job_Submitted_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`转录任务已成功提交。`)
};

const ja_transcription_job_submitted_success = /** @type {(inputs: Transcription_Job_Submitted_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`転写ジョブが正常に送信されました`)
};

const hi_transcription_job_submitted_success = /** @type {(inputs: Transcription_Job_Submitted_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ट्रांसक्रिप्शन कार्य सफलतापूर्वक सबमिट हो गया।`)
};

const pt_pt2_transcription_job_submitted_success = /** @type {(inputs: Transcription_Job_Submitted_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O trabalho de transcrição foi enviado com sucesso.`)
};

/**
* | output |
* | --- |
* | "Transcription job was submitted successfully" |
*
* @param {Transcription_Job_Submitted_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const transcription_job_submitted_success = /** @type {((inputs?: Transcription_Job_Submitted_SuccessInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transcription_Job_Submitted_SuccessInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_transcription_job_submitted_success(inputs)
	if (locale === "de") return de_transcription_job_submitted_success(inputs)
	if (locale === "it") return it_transcription_job_submitted_success(inputs)
	if (locale === "ru") return ru_transcription_job_submitted_success(inputs)
	if (locale === "es") return es_transcription_job_submitted_success(inputs)
	if (locale === "zh-CN") return zh_cn2_transcription_job_submitted_success(inputs)
	if (locale === "ja") return ja_transcription_job_submitted_success(inputs)
	if (locale === "hi") return hi_transcription_job_submitted_success(inputs)
	if (locale === "pt-PT") return pt_pt2_transcription_job_submitted_success(inputs)
	return en_transcription_job_submitted_success(inputs)
});